import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import DateTimePicker from 'react-datetime-picker';
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { creatRequestReq, creatRequestReqStatus } from '../../../redux/request/request.action'
import { shiftListRequest } from '../../../redux/shift/shift.action'
import { employeeListRequest } from '../../../redux/employee/employee.action'
import { API_CONSTANTS, APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import moment from "moment";
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import SubTextLabel from "../../../components/label/sub-text-label/subTextLabel";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import Modal from 'react-bootstrap/Modal';

const AddRequest = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const { shiftListSuccess, shiftListError } = useSelector(state => state.shift)
    const { employeeListSuccess, employeeListError } = useSelector(state => state.employee)
    const { createRequestSuccess, createRequestError, createRequestReqStatus } = useSelector(state => state.request)
    const [requestDate, setRequestDate] = useState(new Date())
    const [description, setDescription] = useState('')
    const [selectedRequestType, setSelectedRequestType] = useState()
    const [selectedEmployee, setSelectedEmployee] = useState()
    const [selectedShift, setSelectedShift] = useState()
    const REQUEST_TYPE = [
        { key: APP_CONSTANTS.EMPLOYEE_REQUEST_TYPE.TIME_OFF, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.EMPLOYEE_REQUEST_TYPE.TIME_OFF) },
        { key: APP_CONSTANTS.EMPLOYEE_REQUEST_TYPE.SICK_DAY, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.EMPLOYEE_REQUEST_TYPE.SICK_DAY) },
        { key: APP_CONSTANTS.EMPLOYEE_REQUEST_TYPE.SHIFT_REQUEST, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.EMPLOYEE_REQUEST_TYPE.SHIFT_REQUEST) },
    ]
    const [isRequestForSelf, setIsRequestForSelf] = useState(false)
    const [isRequestForOther, setIsRequestForOther] = useState(false)
    const [showSuccessModal, setShowSuccessModal] = useState(false)

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.ADD_REQUEST, true)
            fetchBusinessList()
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.ADD_REQUEST) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.ADD_REQUEST, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (!isEmpty(employeeListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(employeeListError)) {
            setLoading(false)
        }
    }, [employeeListSuccess, employeeListError])

    useEffect(() => {
        if (!isEmpty(shiftListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(shiftListError)) {
            setLoading(false)
        }
    }, [shiftListSuccess, shiftListError])

    useEffect(() => {
        if (createRequestReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            setShowSuccessModal(true)
        } else if (createRequestReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(createRequestError.message)
        }
        if (createRequestReqStatus?.length) {
            dispatch(creatRequestReqStatus(''))
        }
    }, [createRequestSuccess, createRequestError, createRequestReqStatus])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (!isNull(selectedLocation) && isLoggedInUserBusiness(user)) {
        }
    }, [selectedLocation])

    const fetchShiftList = () => {
        if (!isEmpty(selectedBusiness) && !isEmpty(selectedLocation)) {
            setLoading(true)
            const data = {
                businessId: selectedBusiness.businessId,
                locationId: selectedLocation.locationId
            }
            dispatch(shiftListRequest(data))
        } else {
            displayErrorToast('Business and business location not selected')
        }
    }

    const fetchEmployeeList = () => {
        if (!isEmpty(selectedBusiness) && !isEmpty(selectedLocation)) {
            setLoading(true)
            const data = {
                businessId: selectedBusiness.businessId,
                locationId: selectedLocation.locationId
            }
            dispatch(employeeListRequest(data))
        } else {
            displayErrorToast('Business and business location not selected')
        }
    }

    useEffect(() => {
        if (!isEmpty(selectedRequestType)) {
            if (selectedRequestType.key === APP_CONSTANTS.EMPLOYEE_REQUEST_TYPE.SHIFT_REQUEST) {
                fetchShiftList()
            }
        }
    }, [selectedRequestType])

    useEffect(() => {
        if (isRequestForOther === true) {
            fetchEmployeeList()
        }
    }, [isRequestForOther])

    const handleItemTypeChoiceChange = type => {
        if (type === 'FOR_SELF') {
            setIsRequestForOther(false)
            setIsRequestForSelf(true)
        } else if (type === 'FOR_OTHER') {
            setIsRequestForOther(true)
            setIsRequestForSelf(false)
        }
    }

    const handleSubmitClick = () => {
        if (isLoggedInUserBusiness(user) && isEmpty(selectedBusiness)) {
            displayErrorToast('Business not selected')
        } else if (isLoggedInUserBusiness(user) && isEmpty(selectedLocation)) {
            displayErrorToast('Business location not selected')
        } else if (isEmpty(selectedRequestType)) {
            displayErrorToast('Request type not selected')
        } else if (isRequestForOther === false && isRequestForSelf === false) {
            displayErrorToast('Request recipient not selected')
        } else if (!isEmpty(selectedRequestType) && selectedRequestType.key === APP_CONSTANTS.EMPLOYEE_REQUEST_TYPE.SHIFT_REQUEST && isEmpty(selectedShift)) {
            displayErrorToast('Shift not selected')
        } else if (isRequestForOther === true && isEmpty(selectedEmployee)) {
            displayErrorToast('Recipient employee not selected')
        } else if (isEmpty(requestDate)) {
            displayErrorToast('Request date not selected')
        } else {
            setLoading(true)
            const data = {
                requestType: selectedRequestType.key,
                requestDate: moment(requestDate).utc().format("YYYY-MM-DD hh:mm:ss A"),
                businessId: selectedBusiness.businessId,
                locationId: selectedLocation.locationId,
                productCode: APP_CONSTANTS.PRODUCT_NAME
            }
            if (!isEmpty(description)) {
                data.description = description
            }
            if (selectedRequestType.key === APP_CONSTANTS.EMPLOYEE_REQUEST_TYPE.SHIFT_REQUEST) {
                if (!isEmpty(selectedShift)) {
                    data.shiftId = selectedShift.shiftId
                }
            }
            if (isRequestForSelf === true) {
                data.requestorId = user.data.userDetails.userId
                data.requestorUserType = user.data.userDetails.userType
            }
            if (isRequestForOther === true) {
                data.requestorId = selectedEmployee.employeeId
                data.requestorUserType = selectedEmployee.userType
            }
            dispatch(creatRequestReq(data))
        }
    }

    const clearFields = () => {
        setRequestDate(new Date())
        setDescription('')
        setSelectedRequestType(undefined)
        setSelectedEmployee(undefined)
        setSelectedShift(undefined)
        setIsRequestForSelf(false)
        setIsRequestForOther(false)
        setShowSuccessModal(false)
    }

    const handleNewTaskAddClick = () => {
        setShowSuccessModal(false)
        clearFields()
    }

    const handleGoBack = () => {
        navigate(-1, { replace: true });
    };

    const getEmployeeCode = (empObj) => {
        let businessId = isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness
        const mappingObj = empObj.employeeBusinessMapping.find(item => parseFloat(item.businessId) === parseFloat(businessId))
        return mappingObj
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='New Request' />
                <CommonFormBorder>
                    <SubTextLabel label='Enter details to raise new request' />
                    <FormFieldLabel label='Select Business' />
                    {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                        className='select-full-width-no-border'
                        value={selectedBusiness}
                        getOptionLabel={e => e.businessName}
                        getOptionValue={e => e}
                        options={userBusinessListSuccess.data}
                        placeholder='Select Business'
                        onChange={e => setSelectedBusiness(e)} />}
                    {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    {!isEmpty(selectedBusiness) && <div>
                        <FormFieldLabel label='Select Business Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                    <FormFieldLabel label='Select request type' />
                    <Select
                        className='select-full-width-no-border'
                        value={selectedRequestType}
                        getOptionLabel={e => e.value}
                        getOptionValue={e => e}
                        options={REQUEST_TYPE}
                        placeholder='Select Request Type'
                        onChange={e => setSelectedRequestType(e)} />
                    <FormFieldLabel label='Select request recipient' />
                    <div className="ap-option-item-container">
                        <label className="ap-choice-label-container">
                            <input type='radio' value='FOR_SELF' checked={isRequestForSelf} onChange={e => handleItemTypeChoiceChange(e.target.value)} />
                            <span className="ap-choice-label">For Self</span>
                        </label>
                        <label className="ap-choice-label-container">
                            <input type='radio' value='FOR_OTHER' checked={isRequestForOther} onChange={e => handleItemTypeChoiceChange(e.target.value)} />
                            <span className="ap-choice-label">For Other</span>
                        </label>
                    </div>
                    {isRequestForOther === true && <div>
                        <FormFieldLabel label='Select Employee' />
                        {!isEmpty(employeeListSuccess) && !isEmpty(employeeListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedEmployee}
                            getOptionLabel={e => `${e.firstName} ${e.lastName} - ${!isEmpty(getEmployeeCode(e)) ? getEmployeeCode(e).employeeCode : 'NA'}`}
                            getOptionValue={e => e}
                            options={employeeListSuccess.data}
                            placeholder='Select Employee'
                            onChange={e => setSelectedEmployee(e)} />}
                        {!isEmpty(employeeListError) && <div className="content-error">{employeeListError.message}</div>}
                    </div>}
                    {!isEmpty(selectedRequestType) && selectedRequestType.key === APP_CONSTANTS.EMPLOYEE_REQUEST_TYPE.SHIFT_REQUEST && <div>
                        <FormFieldLabel label='Select shift' />
                        {!isEmpty(shiftListSuccess) && !isEmpty(shiftListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedShift}
                            getOptionLabel={e => `${e.name} - ${e.openForNomination === true ? 'Open Invitation' : 'Invitation Closed'}`}
                            getOptionValue={e => e}
                            options={shiftListSuccess.data}
                            placeholder='Select Shift'
                            onChange={e => setSelectedShift(e)} />}
                        {!isEmpty(shiftListError) && <div className="content-error">{shiftListError.message}</div>}
                    </div>}
                    <FormFieldLabel label='Select request date' />
                    <DateTimePicker className='margin-bottom-10' onChange={setRequestDate} value={requestDate} />
                    <CommonInputFloatFull
                        type='text'
                        id='description'
                        onChange={e => setDescription(e.target.value)}
                        placeholder='Enter description'
                        value={description}
                        rows={2}
                        multiline={true}
                    />
                    <ButtonRow>
                        <CommonButton label='Submit' onClick={() => { handleSubmitClick() }} />
                    </ButtonRow>
                </CommonFormBorder>
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowSuccessModal(false) }}
                show={showSuccessModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Success
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="at-success-modal-container">
                        <div className="at-success-img-container">
                            <img src={require('../../../assets/success_tick.png')} className="img" />
                        </div>
                        <div className="at-success-text">{createRequestSuccess?.data?.message}</div>
                        <div className="at-next-task-text">Do you want to raise another request?</div>
                        <div className="at-modal-btn-container">
                            <div className="at-modal-no-btn" onClick={() => { handleGoBack() }}>NO</div>
                            <div className="at-modal-yes-btn" onClick={() => { handleNewTaskAddClick() }}>YES</div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default AddRequest